export const state = () => ({
  apiUrl: {
    logDateUrl: '/api/lr/'
  },
  evtLogErrorMessage: null,
  summaryDateResult: []
})
export const mutations = {
  mutEventLogDateList (state, payload) {
    state.summaryDateResult = payload
    state.summaryDateResult = []
  },
  mutEvtLogErrorMessage (state, payload) {
    state.evtLogErrorMessage = payload
  }
}
export const actions = {
  async acsEventLogDateList ({commit, state}) {
    try {
      const res = await this.$axios.$get(state.apiUrl.logDateUrl)
      if (res.code === 'ok') {
        commit('mutEventLogDateList', res.result.msg)
      } else {
        commit('mutEvtLogErrorMessage', res.result.msg)
      }
    } catch (error) {
      commit('mutEvtLogErrorMessage', error)
    }
  }
}
export const getters = {}
export const strict = false
